import "oc-commons/extensions/StringExtensions.js";
import AbstractApp from "oc-app/AbstractApp.js";
import "oc-app/Wkfg2BackendExtensions.js";
import Commons from "oc-commons/Commons.js";
import Stage from "oc-threejs/Stage.js";
import UniversalLoader from "oc-threejs/loader/UniversalLoader.js";
// import Wkfg2BackendApi from "oc-app/Wkfg2BackendApi";
// import Wkfg2TypeConverter from "oc-app/Wkfg2TypeConverter";
import SceneWkfg2Importer from "oc-app/scene/SceneWkfg2Importer";
import Scenes from "oc-threejs/Scenes";
import {v3} from "oc-threejs/short3";
import Jaco from "./arrangement/Jaco";
import Jaco3d from "./arrangement3d/Jaco3d";
import AbstractRichMetadata from "oc-app/AbstractRichMetadata";
import Urls from "oc-commons/Urls";
import {serverCommunicationError} from "oc-ui/errorHandling";
import JacoAppMinimumMixin from "./JacoAppMinimumMixin";

export default class JacoApp extends JacoAppMinimumMixin(AbstractApp) {

    /** @type {string} */
    version;
    /** @type {SceneWkfg2Importer} */
    sceneImporter;

    constructor(name, container, configuratorSettings) {
        super(name, container, configuratorSettings);

        this.version = '<<<<<---RELEASE_NUMBER--->>>>>';

        $.ajaxSetup({
            headers: this.getAjaxHeaders(),
        });

        // this.wkfgBackendApi = this.createWkfgBackendApi();

        this.loadAppData();

    }

    loadAppData() {
        this.addOnUnloadWarning();
        this.loadConfigData({
            code: Urls.urlParam('Code'),
            metamodell: true,
            i18n: true
        }).then(() => {
            this.initApp();
            this.maybeInitAdminApp();
        });
    }

    getStageAsConfiguration() {
        if (this.configuration != null && this.arrangement != null) {
            const configuration = _.clone(this.configuration);
            configuration.Json = Commons.cloneDeep(this.arrangement.toJSON());
            return configuration;
        }
        return this.configuration;
    }

    setStageFromConfiguration(configuration = null) {
        if (configuration == null) {
            configuration = this.createDefaultConfiguration();
        }

        console.log('setStageFromConfiguration', configuration);
        this.configuration = configuration;
        this.arrangement.fromJSON(this.configuration.Json);
        APP.dirty();
    }

    createDefaultConfiguration() {
        return {
            Json: {}
        };
    }

    getAjaxHeaders() {
        return {
            'X-CSRF-Token': this.settings.xcsrfToken,
            'wkfg-tenant': this.settings.tenant_key
        };
    }

    initApp() {
        APP.richMetadata = this.createRichMetadata();
        this.initReadyEventTrigger();
        this.initStage();
        this.initArrangement();
        this.initUI();
        this.loadInitialConfigurationFromApp();
    }

    initReadyEventTrigger() {
        this.onOnce('loadedInitialConfiguration', () => {
            UniversalLoader.delayUntilEverythingLoaded(() => {
                this.trigger('ready');
            }, 'hideInitialLoadingDialog');
        });
    }

    maybeInitAdminApp() {
        // new AdminApp();
    }

    // createWkfgBackendApi() {
    //     return new Wkfg2BackendApi(this.settings.wkfgBackendUrl, this.createWkfgTypeConverter());
    // }

    // createWkfgTypeConverter() {
    //     return new Wkfg2TypeConverter();
    // }

    initStage(envName=null) {
        this.initSceneImporter();

        this.createStage();

        if (STAGE.settings.showDebugObjects) {
            STAGE.addAxisHelper();
        }

        if (STAGE.settings.showGround) {
            STAGE.addGroundScalePaper();
        }

        UniversalLoader.setMaterialFactory(this.sceneImporter);

        if (APP.metadata.Environment) {
            this.sceneImporter.setEnvironment(envName);
        }

        this.interactionHandler = this.createInteractionHandler();
        if (this.interactionHandler) {
            this.interactionHandler.setSceneDroppable();
        }

        STAGE.on('beforeRenderScene', () => this.onBeforeRenderStage());

        STAGE.startRenderLoop();
    }

    initSceneImporter() {
        this.sceneImporter = new SceneWkfg2Importer(this.settings.wkfgContentBaseUrl);
    }

    createStage() {
        return new Stage(this.settings.stage);
    }

    initUI() {
        this.ui = this.createUI();
    }

    createUI() {
    }

    createInteractionHandler() {
    }

    initArrangement() {
        this.arrangement = this.createArrangement();
        this.dirty();
    }

    createArrangement() {
        return new Jaco();
    }

    createRichMetadata() {
        return new AbstractRichMetadata();
    }

}

window.Commons = Commons;
window.$ = $;
